import { render, staticRenderFns } from "./UpdateUserPage.vue?vue&type=template&id=6897c660&scoped=true&lang=pug&"
import script from "./UpdateUserPage.vue?vue&type=script&lang=ts&"
export * from "./UpdateUserPage.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateUserPage.vue?vue&type=style&index=0&id=6897c660&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897c660",
  null
  
)

export default component.exports